

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form12";
const form12State = namespace("Form12");


import { form12DataInfoType, form12PartiesInfoType } from '@/types/Information/Form12';
import { partiesDataJsonDataType, chambersHearingJsonInfoType } from '@/types/Information/json';

import AddPartyForm from './AddPartyForm.vue';
import AddJudgeForm from './AddJudgeForm.vue';
import AddPartyModal from './AddPartyModal.vue';
import { hearingLocationsInfoType } from '@/types/Common';
import {justiceNames} from '@/components/utils/JusticeName';

@Component({
    components:{        
        AddJudgeForm,
        AddPartyForm,
        AddPartyModal        
    }
})
export default class Form12StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @commonState.State
    public hearingLocationsInfo!: hearingLocationsInfoType[];

    @form12State.State
    public currentOrder: chambersHearingJsonInfoType;

    @form12State.State
    public form12Info: form12DataInfoType;

    @form12State.Action
    public UpdateForm12Info!: (newForm12Info: form12DataInfoType) => void  
    
    @form12State.State
    public currentOrderToVarySingleJusticeId: string;

    @form12State.Action
    public UpdateCurrentOrderToVarySingleJusticeId!: (newCurrentOrderToVarySingleJusticeId: string) => void
    
    dataReady = false;
    updated=0; 
    updateOrderDetails = 0;
    orderDateValue = '';
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;

    partyNames: form12PartiesInfoType[] = [];

    addJudgeNamesFormColor = 'court';
    AddNewJudgeNamesForm = false;
    latestEditJudgeNamesData;
    isEditJudgeNamesOpen = false;

    hearingLocationList: string[] = [];
    otherHearingLocationList: string[] = [];
    hearingLocation = "";
    otherHearingLocation = "";

    partyToEdit = {} as form12PartiesInfoType;
    showPartyWindow = false
    isCreate = true
    partyType = ''

    allowedOptions = [
        {text: 'Allowed', value: true},
        {text: 'Dismissed', value: false}
    ];

    responseOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ]; 

    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'counselName', label:'Counsel Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]

    judgeFields = [
        { key:'name', label:'Name', thClass:'text-white bg-court', thStyle: 'font-size: 1rem;', sortable:false },
        { key:'other',label:'', thClass:'text-white bg-court', thStyle: 'font-size: 1rem;', sortable:false},         
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false}
    ]

    state = { 
        appellantsInfo: null,
        respondentsInfo: null,
        judgeNames: null,
        judgeNamesNumber: null,                     
        hearingDate: null,
        hearingLocation: null,
        hearingLocationOther: null,     
        dateOfJudgement: null,
        applyingParties: null,   
        varyingOrderJudgeName: null,
        varyingOrderJudgeNameOther: null,
        varyingOrderDate: null,
        appearingParties: null,
        orderAllowed: null,
        otherOrders: null,
        furtherOrders: null,
        authorizedName: null
    }

    justiceNameOptions = [];
    created(){
        this.justiceNameOptions = justiceNames
    }

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }
    
    public extractInfo(){
        
        this.extractHearingLocations()

        if(this.currentOrderToVarySingleJusticeId){
            this.getForm12Data();
           
        } else { 

            const form12Data = this.form12Info;            
            form12Data.version = this.$store.state.Application.version;
            form12Data.applyingParties = [];
            form12Data.judgeNames = [];
            form12Data.appellants = this.partiesJson.appellants
            form12Data.respondents = this.partiesJson.respondents
            form12Data.formSevenNumber = this.fileNumber; 
            form12Data.appearingParties = [];
            form12Data.applyingParties = [];        
            form12Data.chambersHearing = this.currentOrder;
            this.UpdateForm12Info(form12Data);
            this.initHearingLocation()
            this.revaluateForm12Data()
            this.extractJudgeName()
            this.saveForm(true);
        }          
    }

    public extractJudgeName(){
        const currentOrder = this.form12Info.chambersHearing
        const judgeName = currentOrder && currentOrder.JudgeLastName? (
            (currentOrder.JudgeSalutation? currentOrder.JudgeSalutation+' ':'Justice ')
            +currentOrder.JudgeLastName
        ).trim() : ''

        if(judgeName){
            const justiceIndex = justiceNames.findIndex(name=> name.toLowerCase().includes(judgeName.toLowerCase()))
            if(justiceIndex>-1){
                this.form12Info.varyingOrderJudgeName=justiceNames[justiceIndex]
                this.form12Info.varyingOrderJudgeNameOther=''
            }
            else{
                this.form12Info.varyingOrderJudgeName='Other'
                this.form12Info.varyingOrderJudgeNameOther=judgeName
            }
            this.form12Info.varyingOrderDate= currentOrder.JudgmentDate? currentOrder.JudgmentDate.slice(0,10) : currentOrder.ScheduleDate.slice(0,10)           
        }
        else{
            this.form12Info.varyingOrderJudgeName='';
            this.form12Info.varyingOrderJudgeNameOther='';
            this.form12Info.varyingOrderDate='';
        }
        this.UpdateForm12Info(this.form12Info);
    } 

    public extractHearingLocations(){
        this.hearingLocationList = [];
        
        for (const hearingLocation of this.hearingLocationsInfo){
            if (hearingLocation.other)
                this.otherHearingLocationList.push(hearingLocation.name);
            else 
                this.hearingLocationList.push(hearingLocation.name);                
        }
        this.hearingLocationList.push('Other');
    }
    
    public initHearingLocation(){
        this.hearingLocation = this.form12Info.hearingLocation?.name
        if(this.otherHearingLocationList.includes(this.hearingLocation)){
            this.hearingLocation ='Other'
            this.otherHearingLocation = this.form12Info.hearingLocation.name
        }
    }

    public updateHearingLocation(){ 
              
        const form12 = this.form12Info;       
        form12.hearingLocation = {} as hearingLocationsInfoType;
       
        if (this.hearingLocation == 'Other' && this.otherHearingLocation.length > 0){
            form12.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.otherHearingLocation)[0]
        } else if (this.hearingLocation != 'Other') {
            form12.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.hearingLocation)[0]
        }  
        
        this.UpdateForm12Info(form12);
        this.recheckStates()
    }

    public revaluateForm12Data(){

        const form12Data = this.form12Info;

        for (const respondent of form12Data.respondents){
            if (respondent.firstName && respondent.lastName){                    
                respondent.isOrganization = false;
            } else if (respondent.organization){
                respondent.isOrganization = true;
            }
            if(respondent.solicitor?.counselFirstName && respondent.solicitor?.counselLastName)
                respondent.counselName = respondent.solicitor.counselFirstName+' '+respondent.solicitor.counselLastName                          
            respondent.responding = true;
        }

        for (const applicant of form12Data.appellants){
            if (applicant.firstName && applicant.lastName){
                applicant.isOrganization = false;
            } else if (applicant.organization){
                applicant.isOrganization = true;
            }
            if(applicant.solicitor?.counselFirstName && applicant.solicitor?.counselLastName)
                applicant.counselName = applicant.solicitor.counselFirstName+' '+applicant.solicitor.counselLastName             
            applicant.responding = false;
        }

        const appellants = form12Data.appellants.map(resp=>resp.name)
        const respondents = form12Data.respondents.map(resp=>resp.name)
        form12Data.appellantNames = appellants.join(', ');
        form12Data.respondentNames = respondents.join(', ');

        this.partyNames = [...form12Data.appellants, ...form12Data.respondents]
        this.UpdateForm12Info(form12Data);
    }

    public getForm12Data() {        
       
        this.$http.get('/form12/forms/'+this.currentOrderToVarySingleJusticeId)
        .then((response) => {
            if(response?.data?.data){
                const form12Data = response.data.data
                this.UpdateForm12Info(form12Data);
                this.revaluateForm12Data()
                this.initHearingLocation()
                this.clearStates();                
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellantsInfo: null,
            respondentsInfo: null,
            judgeNames: null,
            judgeNamesNumber: null,        
            hearingDate: null,
            hearingLocation: null,
            hearingLocationOther: null,     
            dateOfJudgement: null,
            applyingParties: null,   
            varyingOrderJudgeName: null,
            varyingOrderJudgeNameOther: null,
            varyingOrderDate: null,
            appearingParties: null,
            orderAllowed: null,
            otherOrders: null,
            furtherOrders: null,
            authorizedName: null
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){  
        
        this.state.appellantsInfo = this.form12Info.appellants?.length>0? null :false;
        this.state.respondentsInfo = this.form12Info.respondents?.length>0? null :false;            
        this.state.judgeNames = this.form12Info.judgeNames?.length>0? null :false;
        this.state.judgeNamesNumber = (this.form12Info.judgeNames?.length==3 || this.form12Info.judgeNames?.length==5)? null :false;
        
        this.state.hearingDate = this.form12Info.hearingDate? null: false;
        this.state.hearingLocation =  this.hearingLocation? null :false
        this.state.hearingLocationOther =  this.hearingLocation=='Other' && !this.otherHearingLocation? false :null
        
        this.state.dateOfJudgement = this.form12Info.dateOfJudgement? null: false;
        this.state.applyingParties = this.form12Info.applyingParties?.length>0? null :false;
        this.state.varyingOrderJudgeName = this.form12Info.varyingOrderJudgeName? null :false;
        this.state.varyingOrderJudgeNameOther = this.form12Info.varyingOrderJudgeName=='Other' && !this.form12Info.varyingOrderJudgeNameOther? false: null;
        this.state.varyingOrderDate = this.form12Info.varyingOrderDate? null :false;
        this.state.appearingParties = this.form12Info.appearingParties?.length>0? null :false;
        this.state.orderAllowed = this.form12Info.orderAllowed == true || this.form12Info.orderAllowed ==false? null :false;
        this.state.otherOrders = this.form12Info.otherOrders == true || this.form12Info.otherOrders ==false? null :false;
        this.state.furtherOrders = this.form12Info.otherOrders == true && !this.form12Info.furtherOrders? false :null

        // this.state.authorizedName = !this.form12Info.authorizedName? false : null;       
        if(dontFindInvalidFields == true) return true

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form12/forms';

        if (this.currentOrderToVarySingleJusticeId){
            method = 'put';
            url = '/form12/forms/'+this.currentOrderToVarySingleJusticeId;
            const form12Data = this.form12Info;            
            this.UpdateForm12Info(form12Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form12Info,
                    type:'Form12',
                    description:'Order from an application to vary or cancel the order of a justice'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form12Info,
                    type:'Form12',
                    description:'Order from an application to vary or cancel the order of a justice'
                }
            }
            this.saveInfo(options, draft);
        }
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentOrderToVarySingleJusticeId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }

    public addNewRespondent(){
        this.state.respondentsInfo = null
        this.partyToEdit = {} as form12PartiesInfoType
        this.partyType = 'Respondent'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editRespondent(data) {
        this.partyToEdit = data.item
        this.partyType = 'Respondent';
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeRespondent(data){ 
        const form12Data = this.form12Info;       
        form12Data.respondents.splice(data.index,1);
        form12Data.respondentNames = form12Data.respondents.map(resp=>resp.name).join(', ');
        this.partyNames = [...form12Data.appellants, ...form12Data.respondents]
        this.somePartiesChanged()
        this.UpdateForm12Info(form12Data);
        this.updated ++;        
    }

    public addNewAppellant(){
        this.state.appellantsInfo = null
        this.partyToEdit = {} as form12PartiesInfoType
        this.partyType = 'Appellant'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editAppellant(data) {
        this.partyToEdit = data.item
        this.partyType = 'Appellant';
        this.isCreate = false;
        this.showPartyWindow = true;        
    }

    public removeAppellant(data){   
        const form12Data = this.form12Info;       
        form12Data.appellants.splice(data.index,1); 
        form12Data.appellantNames = form12Data.appellants.map(resp=>resp.name).join(', ');
        this.partyNames = [...form12Data.appellants, ...form12Data.respondents]        
        this.somePartiesChanged()
        this.UpdateForm12Info(form12Data);
        this.updated ++;        
    }

    public partyChanged(partyCreated){
        if(partyCreated){
            const form12Info = this.form12Info
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                form12Info.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                form12Info.respondents.push(party);
            }
            this.UpdateForm12Info(form12Info)
        }
        this.revaluateForm12Data();
        this.showPartyWindow = false;
        this.somePartiesChanged() 
    }

    public addNewJudgeNames(){
        if(this.isEditJudgeNamesOpen){            
            this.addJudgeNamesFormColor = 'danger'
        }else{
            this.state.judgeNames = null;
            this.AddNewJudgeNamesForm = true;            
        }
    }

    public editJudgeNames(data) {
        // console.log(data)
        if(this.AddNewJudgeNamesForm || this.isEditJudgeNamesOpen){            
            this.addJudgeNamesFormColor = 'danger';                     
        }else if(!this.isEditJudgeNamesOpen && !data.detailsShowing){
            //console.log(data);
            data.toggleDetails();
            this.isEditJudgeNamesOpen = true;
            this.latestEditJudgeNamesData = data;            
        }   
    }

    public modifyJudgeNames(isCreateJudgeNames: boolean, newJudgeName: string, index: number, otherName){        

        const form12Data = this.form12Info;

        if (isCreateJudgeNames){           
            form12Data.judgeNames.push({name: newJudgeName, other: otherName, text: (otherName?otherName:newJudgeName) })            
        } else {                    
            form12Data.judgeNames[index] = {name: newJudgeName, other: otherName, text: (otherName?otherName:newJudgeName) };        
        }
        this.UpdateForm12Info(form12Data)
        this.closeJudgeNamesForm();
        this.state.judgeNamesNumber = (this.form12Info.judgeNames?.length==3 || this.form12Info.judgeNames?.length==5)? null :false;        
        this.updated ++;
    }

    public removeJudgeNames(data){ 
        const form12Data = this.form12Info;       
        form12Data.judgeNames.splice(data.index,1);        
        this.UpdateForm12Info(form12Data);
        this.updated ++;        
    }

    public closeJudgeNamesForm() {                     
        this.AddNewJudgeNamesForm= false; 
        this.addJudgeNamesFormColor = 'court'
        if(this.isEditJudgeNamesOpen){
            this.latestEditJudgeNamesData.toggleDetails();
            this.isEditJudgeNamesOpen = false;
        }
        this.recheckStates() 
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date < day);           
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form12"}) 
    }

    public somePartiesChanged(){
        this.form12Info.applyingParties=[]
        this.form12Info.appearingParties=[]
        this.updated++;
    }


    public getCounselParty(party){

        if(party.counselName){
            const counsel: form12PartiesInfoType = JSON.parse(JSON.stringify(party))
            counsel.isCounsel = true
            counsel.name = counsel.counselName+', counsel for '+counsel.name
            return counsel
        }        
        return party
    }

}
